import { CommonReferenceDataState } from "@idw-types/state/common-reference-data-state"
import { CommonReferenceDataActions, CommonReferenceDataActionTypes } from "@redux/actions/common-reference-data-actions"

export const initialCommonReferenceDataState: CommonReferenceDataState = {
    isLoading: {
        alertEvents: false,
        attributeLabels: false,
        attributeLabelDetails: false,
        dashboard: false,
        messagingTemplates: false,
        messagingTemplateDetails: false,
        messageTemplates: false,
        messageTemplateDetails: false,
        organizations: false,
        organizationActivity: false,
        organizationDetails: false,
        organizationInvitationDetails: false,
        organizationInvitations: false,
        organizationUserDetails: false,
        organizationUsers: false,
        policyComponentDetails: false,
        policyComponents: false,
        relyingParties: false,
        relyingPartyDetails: false,
        verificationTransactions: false,
        workflowReport: false,
        workflowTemplates: false,
        verificationServices: false,
        verificationServiceDetails: false,
        verificationTransactionDetails: false,
        workflowDetails: false,
        workflowTemplateDetails: false,
        workflowUsageDetails: false,
        workflows: false,
        serviceTemplates: false,
        serviceTemplateDetails: false
    },
    alert: null,
    apAssertions: null,
    assertionScoreAssertionStatusValueMaps: null,
    assertionScoreServiceOfferings: null,
    assertionStatusDefaults: null,
    attributeClassifications: null,
    auth0IdentityProviders: null,
    availableAssertionScoreValues: null,
    availableTrustScoreValues: null,
    axnCompanies: null,
    axnAcquiredAttributes: null,
    axnAdminAvailableUserOrganizationProperties: null,
    axnAdminAvailableUserRPProperties: null,
    axnAdminUserPropertyBundles: null,
    axnAdminUserPropertyCategories: null,
    axnAdminWorkflows: null,
    axnAssertions: null,
    axnAssertionAttributes: null,
    axnAssertionStatusMaps: null,
    axnAttributeLabels: null,
    axnAttributeTypes: null,
    axnAttributeTypeFields: null,
    axnAttributeTypeFieldCustomizations: null,
    axnAvailableAssertionStatuses: null,
    axnAvailablePropertyCategories: null,
    axnCountries: null,
    axnIdentityProviders: null,
    axnPropertyTypes: null,
    axnRelyingParties: null,
    axnRPServices: null,
    axnRPServicesWithSOIDs: null,
    axnSelectedServiceOfferingSOs: null,
    axnServiceOfferings: null,
    axnServiceOfferingCategories: null,
    axnServiceOfferingDataSources: null,
    axnServiceOfferingProcessingTypes: null,
    axnTransactionTypes: null,
    claimStatuses: null,
    customerSupportTiers: null,
    deployedPolicyComponents: null,
    documentationLinks: null,
    messageTemplate: null,
    fallbackServiceMappings: null,
    messagingTemplates: null,
    policyDecisions: null,
    riskLevels: null,
    rpServiceAttributeProperties: null,
    rpServiceAttributePropertyMaps: null,
    rpServiceTemplates: null,
    rpServiceTypes: null,
    scoreAttributeMaps: null,
    selfServiceVerificationAttributes: null,
    selfServiceVerificationMessageTemplates: null,
    selfServiceVerificationWhiteLabeledEmails: null,
    serviceOfferingRefreshRateDefault: null,
    serviceOfferingRefreshRates: null,
    simpleAXNAdminRPServiceWorkflows: null,
    simpleAXNRPServices: null,
    simpleAXNRPServiceWorkflows: null,
    simpleAXNWorkflows: null,
    simpleDeployedPolicyComponentConditions: null,
    simpleDeployedPolicyConfigDecisions: null,
    simpleDeployedPolicyConfigs: null,
    trustScoreAssertionStatusValueMaps: null,
    trustScoreServiceOfferings: null,
    workflowRedirectURLs: null,
    workflowTemplates: null
}

export const commonReferenceDataReducer = (state: CommonReferenceDataState = initialCommonReferenceDataState, action: CommonReferenceDataActions): CommonReferenceDataState => {
    switch (action.type) {
        case CommonReferenceDataActionTypes.SET_PARTIAL_COMMON_REFERENCE_DATA: {
            return {
                ...state,
                ...action.payload.partialReferenceData,
                isLoading: action.payload.commonReferenceDataPageType ? {
                    ...state.isLoading,
                    [action.payload.commonReferenceDataPageType]: false
                } : state.isLoading
            };
        }
        case CommonReferenceDataActionTypes.SET_PARTIAL_COMMON_REFERENCE_DATA_LOADING: {
            return action.payload.commonReferenceDataPageType ? {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.payload.commonReferenceDataPageType]: action.payload.isLoading
                }
            } : state;
        }
        case CommonReferenceDataActionTypes.ADD_OBJECTS_TO_ARRAY_IN_COMMON_REFERENCE_DATA: {
            return {
                ...state,
                [action.payload.referenceDataType]: [
                    ...state[action.payload.referenceDataType],
                    ...action.payload.objectsToAdd
                ]
            }
        }
        default:
            return state;
    }
};